export default "__VITE_ASSET__51e042d0__"